import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_TAI_SAN_THEO_CHO_VAY,
  GET_TAI_SAN,
  GET_LICH_SU_TAI_SAN,
} from "actions/TaiSan/actionTypes";
import {
  getTaiSanTheoChoVaySuccess,
  getTaiSanTheoChoVayFailure,
  getTaiSanFailure,
  getTaiSanSuccess,
  getLichSuTaiSanSuccess,
  getLichSuTaiSanFailure,
} from "actions/TaiSan";
import TaiSanApi from "service/taiSanApi";
import { pushNotification } from "utils/notifications";

function* getTaiSanTheoChoVay(action) {
  try {
    const response = yield call(TaiSanApi.taiSanTheoChoVay, action.dataSearch);
    if (response.ok) {
      yield put(getTaiSanTheoChoVaySuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getTaiSanTheoChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getTaiSanTheoChoVayFailure());
  }
}
function* getTaiSan(action) {
  try {
    const response = yield call(TaiSanApi.getDetail, action.dataSearch);
    if (response.ok) {
      yield put(getTaiSanSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getTaiSanFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getTaiSanFailure());
  }
}
function* getLichSuTaiSan(action) {
  try {
    const response = yield call(TaiSanApi.getLichSuTaiSan, action.dataSearch);
    if (response.ok) {
      yield put(getLichSuTaiSanSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getLichSuTaiSanFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getLichSuTaiSanFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_TAI_SAN_THEO_CHO_VAY, getTaiSanTheoChoVay);
  yield takeLatest(GET_TAI_SAN, getTaiSan);
  yield takeLatest(GET_LICH_SU_TAI_SAN, getLichSuTaiSan);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
